import {Component, inject} from '@angular/core'
import {RouterOutlet} from '@angular/router'
import {FooterComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import version from '../assets/package.json'
import {HeaderComponent} from './components/header/header.component'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'

@Component({
  selector: 'spb-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [
    HeaderComponent,
    RouterOutlet,
    FooterComponent
  ]
})
export class AppComponent {
  public version = version.version
  public configService = inject(ConfigService)
  public copyrightYears = `2024-${new Date().getFullYear()}`
}
